export default {
    B2B: 'B2B Partnerships (Travel Agents/Airline)',
    CPSP: 'Connectivity provider/Software provider',
    ACTIVITIES: 'Activities/Tours/Attractions',
    PM: 'Property manager/Hotelier',
};
